import { z } from 'zod';

import { cnpjSchema } from '@/utils/schema/cnpj';

export const companySchema = z.object({
  tradingName: z.string().min(1),
  registrationNumber: z.string().min(1).pipe(cnpjSchema),
  companyName: z.string().min(1),
});

export type ICompanyFormSchema = z.infer<typeof companySchema>;
